export default __webpack_public_path__ + "static/media/method_thumbnail_2.80556932.jpg";